import { render, staticRenderFns } from "./DashboardDoughnut.vue?vue&type=template&id=5a36825e&"
import script from "./DashboardDoughnut.vue?vue&type=script&lang=js&"
export * from "./DashboardDoughnut.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDoughnut.vue?vue&type=style&index=0&id=5a36825e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports